import React from "react"
import { Text, Button, CreditCardInput, Box } from "dash-styled"
import { APIPaymentMethodModel } from "../../../../../../Models/API/BillingModel"
import { useAsyncCommand } from "../../../../../../Hooks/useAsyncCommand"

interface PaymentMethodRowProps {
    model: APIPaymentMethodModel
    onDelete?: () => Promise<void>
}

export const PaymentMethodRow = ({
    model,
    onDelete
}: PaymentMethodRowProps) => {
    const { perform, isProcessing } = useAsyncCommand(onDelete)

    return (
        <Box marginBottom="7">
            <CreditCardInput
                cardNumberId=""
                cardNumberInput={
                    <Box>
                        <Text
                            color="gray"
                            component="span"
                            size="xxl"
                            style={{ letterSpacing: "6px" }}
                        >
                            •••• •••• ••••{" "}
                        </Text>
                        <Text
                            component="span"
                            size="xxl"
                            style={{ letterSpacing: "6px" }}
                        >
                            {model.name.replace(/^Ending with: /, "")}
                        </Text>
                    </Box>
                }
                ownerId=""
                ownerInput={
                    model.address === undefined ||
                    model.address.name === null ? (
                        <Text color="gray">-</Text>
                    ) : (
                        <Text color="darkviolet">{model.address.name}</Text>
                    )
                }
                expireId=""
                expireInput={<Text>•• / ••</Text>}
                cvvId=""
                cvvInput={<Text>•••</Text>}
            />
            <Button
                variant="contained"
                color="red"
                onClick={perform}
                disabled={isProcessing}
            >
                {isProcessing ? "Deleting..." : "Delete"}
            </Button>
        </Box>
    )
}
